import { Injectable } from '@angular/core';

import { I18nLocaleFactory } from '../../../i18n/i18n.module';
import { I18nService } from '../../../i18n/i18n.service';

import { DateTimeLocaleProvider } from './datetime-locale-provider';

@Injectable()
export class DateTimeI18nLocaleProvider extends DateTimeLocaleProvider {
    constructor(private readonly _i18nService: I18nService) {
        super();
    }

    locale(): string {
        return I18nLocaleFactory(this._i18nService);
    }
}
